// region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Class to handle API calls
//
//  Copyright:    © 2025 - 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
// region Version 1.0.0.0
//    001   20.02.25 Sean Flook          GMSCM-1 Initial Revision.
//    002   13.03.25 Sean Flook         GMSCM-11 Use versioning for baseUrl.
// endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
// endregion header

import axios, { AxiosInstance } from "axios";
import { getConfigValue } from "../configuration/runtimeEnv";

class APIClient<T> {
  endpoint: string;
  userToken: string;
  private _axiosInstance: AxiosInstance;

  constructor(endpoint: string, userToken: string) {
    this.userToken = userToken;
    this.endpoint = endpoint;

    const multiTenantApi = getConfigValue("REACT_APP_MULTI_TENANT_API", process.env.REACT_APP_MULTI_TENANT_API);
    const multiTenantVersion = getConfigValue(
      "REACT_APP_MULTI_TENANT_VERSION",
      process.env.REACT_APP_MULTI_TENANT_VERSION
    );
    const baseURL = `${multiTenantApi}/api/v${multiTenantVersion}`;

    this._axiosInstance = axios.create({
      baseURL: baseURL,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.userToken,
      },
    });
  }

  getAll = () => {
    return this._axiosInstance.get<T[]>(this.endpoint).then((response) => response.data);
  };

  post = (data: T) => {
    return this._axiosInstance.post<T>(this.endpoint, data).then((response) => response.data);
  };

  put = (data: T) => {
    return this._axiosInstance.put<T>(this.endpoint, data).then((response) => response.data);
  };
}

export default APIClient;
